export default {
  "cancel": "Cancel",
  "close": "Close",
  "closeDialog": "Close dialog",
  "retry": "Retry",
  "refresh": "Refresh",
  "unknown": "Unknown",
  "failed": "Failed",
  "current": "Current",
  "completed": "Completed",
  "connecting": "Connecting",
  "systemResponse": "System Response",
  "version": "Version",
  "pathCopied": "Path copied to clipboard",
  "copyPathFailed": "Failed to copy path",
  "fileNotFound": "File not found",
  "missing": "Missing",
  "copyPath": "Copy path",
  "revealApiFailed": "Failed to reveal API key",
  "apiCopied": "API key copied to clipboard",
  "copyApiFailed": "Failed to copy API key",
  "copyApi": "Copy API key",
  "reveal": "Reveal",
  "features": "Features",
  "loadingDetails": "Loading details...",
  "paths": "Paths",
  "config": "Config",
  "log": "Log",
  "install": "Install",
  "reinstall": "Reinstall",
  "uninstall": "Uninstall",
  "apiKey": "API Key",
  "quickboxDocs": "QuickBox Docs",
  "docs": "Docs",
  "website": "Website",
  "fetchDetailsFailed": "Failed to fetch details",
  "viewDetails": "View details",
  "ready": "Ready",
  "queued": "Queued",
  "migrating": "Migrating",
  "installing": "Installing",
  "reinstalling": "Reinstalling",
  "removing": "Removing",
  "updating": "Updating",
  "installed": "Installed",
  "removed": "Removed",
  "reinstalled": "Reinstalled",
  "updated": "Updated",
  "complete": "Complete",
  "cancelled": "Cancelled",
  "running": "Running",
  "processing": "Processing",
  "logsDetails": "Check logs for details",
  "switchChannelFailed": "Failed to switch channel",
  "channelChangeFailed": "Channel change failed",
  "channelUpdated": "Channel updated",
  "versionInstall": "Version Install",
  "releaseChannel": "Release Channel",
  "selected": "Selected",
  "latest": "Latest",
  "switchUpdate": "Switch & Update Now",
  "saveChannel": "Save Channel",
  "updatingPackage": "Updating package...",
  "reinstallComplete": "Reinstall complete.",
  "updateComplete": "Update complete.",
  "updateFailed": "Update failed.",
  "copyLogs": "Copy logs",
  "jobCancelled": "Job cancelled.",
  "default": "Default",
  "cancelReported": "Job cancelled — report sent to admins",
  "cancelSuccess": "Job cancelled",
  "somethingWrong": "Something went wrong. Please try again.",
  "cancelThisJob": "Cancel this job",
  "cancelJob": "Cancel job",
  "cancelQuestion": "Cancel this job?",
  "reportAdmins": "Report this issue to administrators",
  "adminMessagePlaceholder": "Tell admins what happened (optional)",
  "adminMessage": "Message for administrators",
  "keepRunning": "Keep running",
  "stopping": "Stopping…",
  "cancelFailed": "Failed to cancel job",
  "unexpectedResponse": "Unexpected response from server",
  "loadingPreview": "Loading preview...",
  "afterInstall": "After Installation",
  "selectMount": "Select a mount point to preview changes",
  "reauthorize": "Re-authorize",
  "tryAgain": "Try again",
  "authorize": "Authorize",
  "authorizationExpired": "Authorization session expired or not found. Please re-authorize.",
  "tokenFailed": "Failed to retrieve authorization token.",
  "tokenNetwork": "Network error while retrieving token. Please re-authorize.",
  "optionsFailed": "Failed to load options",
  "previewFailed": "Failed to load preview",
  "plexVerifyFailed": "Plex couldn't verify these credentials. Check your email, password, and 2FA code, then try again.",
  "plexEnterCredentials": "Enter your plex.tv email and password to install the Plex Pass channel.",
  "hidePassword": "Hide password",
  "showPassword": "Show password",
  "licenseDrop": "or drag and drop a license file",
  "loadingOptions": "Loading options...",
  "noOptions": "No options available",
  "select": "Select...",
  "dnsMissing": "No saved credentials for this DNS provider.",
  "dnsInstallWarning": "The certificate request will fail unless credentials are added before install.",
  "addDnsCredentials": "Add credentials in SSL Control",
  "clientIdRequired": "OAuth Client ID is required before authorizing",
  "clientSecretRequired": "OAuth Client Secret is required before authorizing",
  "authorizationUrlMissing": "Backend did not return an authorization URL.",
  "authorizationNetwork": "Network error while starting authorization. Please try again.",
  "recommended": "Recommended",
  "plexSignIn": "Plex Pass account sign-in",
  "oauthFirst": "Complete OAuth authorization before installing",
  "noDescription": "No description available",
  "notInstalled": "Not Installed",
  "deprecated": "Deprecated",
  "migrate": "Migrate",
  "deprecatedMigrateHint": "Deprecated. Migrate to {{target}}.",
  "actions": "Actions",
  "searchPackages": "Search packages...",
  "allCategories": "All Categories",
  "allPackages": "All Packages",
  "installedOnly": "Installed Only",
  "loadingPackages": "Loading packages...",
  "noPackages": "No packages found",
  "clearFilters": "Clear filters",
  "notAuthenticated": "Not authenticated",
  "noJobId": "No job ID returned from server",
  "noInstall": "No install in progress",
  "plexUpdateFailed": "Failed to start Plex update",
  "plexCredentialsRequired": "PlexPass credentials required",
  "plexChannelRequired": "Plex channel selection required",
  "cannotRemoveDispatcharr": "Cannot remove Dispatcharr yet",
  "dispatcharrUsers": "Users still holding Dispatcharr:",
  "selectPlexChannel": "Select Plex Channel",
  "plexSubscription": "Choose your Plex subscription type",
  "plexChannel": "Plex channel",
  "plexDetectFailed": "Could not auto-detect your Plex subscription. Select the channel that matches your account.",
  "plexPassDescription": "You have an active PlexPass subscription. Credentials required to download.",
  "free": "Free",
  "plexFreeDescription": "Using the public free release. No credentials needed.",
  "continue": "Continue",
  "plexEmail": "Plex.tv Email",
  "password": "Password",
  "plexPassword": "Your plex.tv password",
  "twoFactor": "Two-Factor Code",
  "noTwoFactor": "Leave blank if no 2FA",
  "otpPlaceholder": "6-digit code (optional)",
  "plexSignInRequired": "Plex.tv Sign-in Required",
  "plexAuthentication": "PlexPass downloads require authentication",
  "versionSelector": "Version selector",
  "availableVersions": "Available Versions",
  "loadingVersions": "Loading versions...",
  "showUpdateBadge": "Show update badge",
  "hideUpdateBadge": "Hide update badge",
  "noPackage": "No package specified",
  "networkError": "Network error",
  "versionsFailed": "Failed to fetch versions",
  "credentialsCheckFailed": "Failed to check credentials",
  "credentialsSaveFailed": "Failed to save credentials",
  "credentialsSaved": "Credentials saved successfully",
  "packagesFailed": "Failed to fetch packages",
  "installStartFailed": "Failed to start installation",
  "removeStartFailed": "Failed to start removal",
  "reinstallStartFailed": "Failed to start reinstall",
  "updateStartFailed": "Failed to start update",
  "installStarted": "Installation started",
  "removeStarted": "Removal started",
  "reinstallStarted": "Reinstall started",
  "updateStarted": "Update started",
  "systemAppsFailed": "Failed to fetch system apps status",
  "invalidResponse": "Invalid response",
  "requiredField": "{{field}} is required",
  "errorStatus": "{{message}} (HTTP {{status}})",
  "installApp": "Install {{app}}",
  "reinstallApp": "Reinstall {{app}}",
  "updateApp": "Update {{app}}",
  "installingApp": "Installing {{app}}",
  "updatingApp": "Updating {{app}}",
  "reinstallingApp": "Reinstalling {{app}}",
  "installDone": "{{app}} installed successfully",
  "reinstallDone": "{{app}} reinstalled successfully",
  "updateDone": "{{app}} updated successfully",
  "removeDone": "{{app}} removed successfully",
  "installFailed": "Failed to install {{app}}",
  "reinstallFailed": "Failed to reinstall {{app}}",
  "updateAppFailed": "Failed to update {{app}}",
  "removeFailed": "Failed to remove {{app}}",
  "operationSuccess": "Package operation completed successfully.",
  "operationError": "An error occurred during the operation.",
  "operationExit": "Operation failed (exit code {{code}}).",
  "operationFailed": "Operation failed.",
  "migrateTo": "Migrate to {{target}}",
  "migrationDone": "Migration to {{target}} complete",
  "migrationFailed": "Migration to {{target}} failed",
  "migratingTo": "Migrating to {{target}}...",
  "migrateApp": "Migrate {{app}} to {{target}}",
  "migrateQuestion": "Migrate {{app}} to {{target}}?",
  "installVersion": "Install {{app}} {{version}}",
  "installingVersion": "Installing {{app}} {{version}}...",
  "versionFailed": "Install of {{version}} failed.",
  "channelSettings": "{{app}} — Channel Settings",
  "updateChannel": "Update {{app}} ({{channel}})",
  "channelNow": "{{app}} is now on the {{channel}} channel",
  "latestTarget": "{{target}} latest",
  "noVersions": "No versions available for {{app}}",
  "charactersLeft_one": "{{displayCount}} character left",
  "charactersLeft_other": "{{displayCount}} characters left",
  "packages_one": "{{displayCount}} package",
  "packages_other": "{{displayCount}} packages",
  "packagesFiltered": "{{packages}} ({{filter}})",
  "removeFile": "Remove {{file}}",
  "fileSize": "({{size}} KB)",
  "fstabContent": "{{label}} fstab content",
  "mountMissing": "Mount point {{mount}} was not found in /etc/fstab.",
  "mountChange": "Mount point {{mount}} will be modified to enable disk quotas.",
  "mountReady": "Mount point {{mount}} already has disk quota options configured.",
  "authorizeProvider": "Authorize {{provider}}",
  "oauthPrompt": "Click Authorize below to connect your account. You will be redirected to {{provider}} and returned here automatically.",
  "oauthFetching": "Retrieving authorization token from {{provider}}…",
  "oauthReady": "{{provider}} authorized — ready to install.",
  "plexCredentialsUse": "These credentials are used only for this operation and are not stored or shared outside of this instance.",
  "startingInstall": "Starting installation…",
  "startingReinstall": "Starting reinstallation…",
  "startingUpdate": "Starting update…",
  "cancelPackageWarning": "This will stop the package operation. The package may be left in a partial state — reinstall to recover.",
  "cancelVpnWarning": "This will stop the WireGuard operation. You can retry afterwards.",
  "cancelSslWarning": "This will stop the certificate operation. You can retry or reissue afterwards.",
  "cancelUpdateWarning": "This will stop the update operation. QuickBox state is preserved — you can re-run the update.",
  "confirmMigration": "This will migrate your {{app}} installation to {{target}}. Your existing configuration and database will be preserved.",
  "confirmVersion": "Install {{app}} version {{version}}? This will reinstall the package at the selected version.",
  "confirmUpdate": "Update {{app}} to the latest version?",
  "manageChannel": "Manage the release channel for {{app}}.",
  "plexChannelWarning": "The Plex Pass channel requires a signed-in Plex account, set up when you install or update Plex. Update checks fall back to the Public channel until an account token is present.",
  "channelDowngrade": "Your installed version ({{version}}) may be newer than the latest {{channel}} release. The next update will install the {{channel}} version.",
  "migrationRestart": "{{app}} will be replaced by {{target}}. The service may restart during migration. Active connections could be interrupted briefly.",
  "reinstallRestart": "The application service will restart during reinstallation. Active connections could be interrupted briefly.",
  "updateRestart": "The application service may restart during the update. Active connections could be interrupted briefly.",
  "replaceMigration": "This will replace {{app}} with {{target}}. Your settings, request history, and user accounts will be preserved during migration. This action cannot be undone.",
  "plexInstallCredentials": "The Plex Pass channel downloads beta builds and requires a signed-in plex.tv account. Enter your credentials below (two-factor code only if your account has 2FA enabled). They're used once for this install and are never stored.",
  "providerGuide": "Full {{provider}} setup guide",
  "dropboxSetup": "First time setting up Dropbox? Create a developer app using the link below, register this dashboard's callback URL on the Settings tab, and enable the required scopes on the Permissions tab.",
  "gdriveSetup": "First time setting up Google Drive? Create a Google Cloud OAuth app: enable the Drive API, configure the consent screen with the three required scopes, and create a Web application client. Expect an “unverified app” warning during authorization; this is normal for personal-use apps and is safe to bypass.",
  "ulozSetup": "Uloz.to uses direct credentials, without OAuth. You need your account username, password, and an app token from the link below. The app token is separate from your account password.",
  "beta": "Beta",
  "requestFailed": "Request failed (HTTP {{status}})",
  "updateExit": "Update failed (exit code {{code}})",
  "migrationDoneSentence": "Migration to {{target}} complete.",
  "tokenRequestFailed": "Token fetch failed (HTTP {{status}})",
  "optionsRequestFailed": "Failed to load options (HTTP {{status}})",
  "previewRequestFailed": "Preview request failed (HTTP {{status}})",
  "authorizationRequestFailed": "Failed to start authorization (HTTP {{status}})",
  "unknownError": "Unknown error",
  "legacy": "Legacy"
} as const;
